import * as React from "react";
import styled, { useTheme } from "styled-components";

import ModalLayout from "../ModalLayout";
import { Typography } from "@mui/material";

import ButtonIcon from "components/ui-kit/ButtonIcon";
import CheckIcon from "@mui/icons-material/Check";

const ModalToggleKitchenShift = ({
    // state
    isOpen,
    shiftStatus,
    // mapDispatch
    closeModalToggleKitchenShift,
    toggleKitchenShiftStatus,
}) => {
    const theme = useTheme();
    const text = React.useMemo(() => {
        const { isShiftClosed, shiftId } = shiftStatus;
        const shiftStatusTextArray = [
            isShiftClosed ? "відкрити" : "закрити",
            "зміну",
        ];

        if (shiftId !== null) {
            shiftStatusTextArray.push(`№${shiftId}`);
        }

        return shiftStatusTextArray.join(" ");
    }, [shiftStatus]);

    // const shiftIdText = React.useMemo(() => {
    //     const { shiftId } = shiftStatus;
    //     return shiftId && <Typography variant="subtitle2">{shiftId}</Typography>
    // }, [shiftStatus]);

    const toggleShift = React.useCallback(() => {
        closeModalToggleKitchenShift(); // close modal
        toggleKitchenShiftStatus(); // toggle kitchen shift status
    }, [toggleKitchenShiftStatus, closeModalToggleKitchenShift]);

    return (
        <ModalLayout
            theme={theme}
            modalIsOpen={isOpen}
            closeModal={closeModalToggleKitchenShift}>
            <Title>
                <Typography variant="h5">Пропонуємо {text}</Typography>
            </Title>
            <RowBtn>
                <Item>
                    <ButtonIcon
                        onClick={toggleShift}
                        title="Так"
                        icon={<CheckIcon />}
                    />
                </Item>
                <Item>
                    <ButtonIcon
                        onClick={closeModalToggleKitchenShift}
                        title="Ні"
                    />
                </Item>
            </RowBtn>
        </ModalLayout>
    );
};

const Title = styled.div`
    text-align: center;
    font-size: 18px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid ${(p) => p.theme.accentColor};
    font-weight: 700;
`;

const RowBtn = styled.div`
    display: flex;
    align-items: center;
    margin-top: 40px;
    justify-content: center;
`;

const Item = styled.div`
    padding: 0 5px;
`;

export default ModalToggleKitchenShift;
